import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

interface DefaultColorPickerTriggerProps {
  color: string
}

export const DefaultColorPickerTrigger = styled.div<DefaultColorPickerTriggerProps>`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: ${BorderRadius.R8};
  position: relative;
  background-color: ${({ color }) => color};
  cursor: pointer;
`

export const DefaultColorPickerWrapper = styled.div`
  width: 240px;
  height: 240px;
  margin-top: ${Spacing.S6};
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey150};
  border-radius: ${BorderRadius.R8};
  background-color: ${Color.White};
  box-shadow: 0 5px 5px 0 ${transparentize(0.15, Color.Grey150)};
`
